import { frontendURL } from '../../../helper/URLHelper';
import CompaniesIndex from './pages/CompaniesIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.COMPANIES,
  permissions: ['administrator', 'agent'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

// Polaris (fase 5.6, R2-5-PC-9 = A): an open company is a drawer over the companies list, the contact's rule (Q4).
// `companies_dashboard_show` keeps its name and URL (/companies/:companyId) and is a child of the list, so the same
// CompaniesIndex stays mounted when a company opens, changes or closes.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/companies'),
    component: CompaniesIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'companies_dashboard_index',
        component: CompaniesIndex,
        meta: commonMeta,
      },
      {
        path: ':companyId(\\d+)',
        name: 'companies_dashboard_show',
        component: CompaniesIndex,
        meta: commonMeta,
      },
    ],
  },
];
